export enum EAnalyticMetricKey {
  AVG_TIME = 'AVG_TIME',
  AVG_SCROLL_DEPTH = 'AVG_SCROLL_DEPTH',
  SESSIONS = 'SESSIONS',
  ENGAGED_SESSIONS = 'ENGAGED_SESSIONS',
  ENGAGED_SESSIONS_DEVICE = 'ENGAGED_SESSIONS_DEVICE',
  PAGE_VIEWS = 'PAGE_VIEWS',
  ORDERS = 'ORDERS',
  REVENUE = 'REVENUE',
  CLICKS = 'CLICKS',
}
